module.exports = __webpack_public_path__ + "fonts/Raleway-SemiBoldItalic.9c44728b.woff2";